import React from "react";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { BrowserRouter } from "react-router-dom";

import Site from "components/Site";
import ConfigProvider from "config";
import IdentityProvider from "identity";
import { GlobalThemeProvider } from "theme";
import {
  theme as muiTheme,
  ThemeProvider as MuiThemeProvider
} from "theme/MuiTheme";

import "./App.css";

type AppProps = {
  msalInstance: PublicClientApplication;
};

const App: React.FC<AppProps> = props => {
  const { msalInstance } = props;
  return (
    <MsalProvider instance={msalInstance}>
      <div id="appContainer">
        <GlobalThemeProvider>
          <MuiThemeProvider theme={muiTheme}>
            <ConfigProvider>
              <IdentityProvider>
                <BrowserRouter>
                  <Site />
                </BrowserRouter>
              </IdentityProvider>
            </ConfigProvider>
          </MuiThemeProvider>
        </GlobalThemeProvider>
      </div>
    </MsalProvider>
  );
};

export default App;
